export const DEFAULT_SRC = 'https://via.placeholder.com/300'
export const DEFAULT_ALT = 'Image Alt'
